// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__nNjkE","clickable":"icon_clickable__qwC2o","left":"icon_left__FJ4mf"};